<form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>{{ Product && 'edit' || 'add' }}</mat-icon>
      {{ Product && 'Edit' || 'Add' }} Product
    </h1>
  </section>
  <section mat-dialog-content>
    <section class="items">
      <mat-form-field>
        <mat-label>Title</mat-label>
        <input formControlName="title" matInput type="text" />
      </mat-form-field>
      <mat-form-field>
        <mat-label
          >Total Items (sold: {{itemsSold}}, available:
          {{form.controls['totalTickets'].value - itemsSold}})
        </mat-label>
        <input
          [min]="itemsSold"
          formControlName="totalTickets"
          matInput
          type="number"
          />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Items Per Partner</mat-label>
        <input
          formControlName="ticketsPerPartner"
          matInput
          step="0.01"
          type="number"
          />
      </mat-form-field>
    </section>
    <section class="prices">
      <h2>Price</h2>
      <mat-form-field>
        <mat-label>Item Price</mat-label>
        <span matPrefix>&pound;&nbsp;</span>
        <input formControlName="price" matInput step="0.01" type="number" />
      </mat-form-field>
    </section>
      <section class="repeatable-purchase">
        <h2>Orders</h2>
        <mat-slide-toggle formControlName="repeatablePurchase">
          Allow repeat purchases
        </mat-slide-toggle>
        <p>
          When enabled, partners can place another order for this item after they
          already have a completed or authorised order.
        </p>
      </section>
    <section class="delivery">
      <h2>Delivery</h2>
      <mat-form-field>
        <mat-select
          (selectionChange)="onSelectDeliveryMethod($event)"
          formControlName="deliveryMethod"
          placeholder="Delivery Method"
          required
          >
          @for (method of deliveryMethods; track method) {
            <mat-option [value]="method">
              {{method.label}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (showDeliveryPrice) {
        <mat-form-field>
          <mat-label>{{ deliveryMethods[0].label }} Price</mat-label>
          <span matPrefix>&pound;&nbsp;</span>
          <input disabled matInput type="text" value="FREE" />
        </mat-form-field>
        <mat-form-field>
          <mat-label
            >{{ form.controls['deliveryMethod'].value.label }} Price</mat-label
            >
            <span matPrefix>&pound;&nbsp;</span>
            <input
              formControlName="deliveryPrice"
              matInput
              step="0.01"
              type="number"
              />
          </mat-form-field>
        }
      </section>
    </section>
    <section align="end" mat-dialog-actions>
      <button
        mat-button
        mat-dialog-close
        matTooltip="Cancel and close."
        type="button"
        >
        <mat-icon>cancel</mat-icon>
        Cancel
      </button>
      <button
        (click)="resetForm()"
        mat-button
        matTooltip="Reset form."
        type="button"
        >
        <mat-icon>replay</mat-icon>
        Reset
      </button>
      <button
        [disabled]="!form.valid"
        mat-button
        matTooltip="Save item."
        type="submit"
        >
        <mat-icon>save</mat-icon>
        Save
      </button>
    </section>
  </form>
